import type { ReactNode } from 'react';

/** Up to two initials from a display name ("Ana Ferreira" → "AF"). */
export function initialsOf(name?: string | null): string {
  return (name ?? 'U')
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((s) => s[0]?.toUpperCase() ?? '')
    .join('');
}

/**
 * First column of a people list: an initials avatar, the name (usually a
 * link, passed as children) and an optional secondary line.
 */
export function PersonCell({
  name,
  sub,
  children,
}: {
  name?: string | null;
  sub?: ReactNode;
  children: ReactNode;
}) {
  return (
    <span className="person-cell">
      <span className="avatar" aria-hidden="true">
        {initialsOf(name)}
      </span>
      <span className="person-cell-text">
        <span className="person-cell-name">{children}</span>
        {sub && <small>{sub}</small>}
      </span>
    </span>
  );
}
